// export const COURSE_CREATE_REQUEST = "COURSE_CREATE_REQUEST";
// export const COURSE_CREATE_SUCCESS = "COURSE_CREATE_SUCCESS";
// export const COURSE_CREATE_FAIL = "COURSE_CREATE_FAIL";
// export const COURSE_CREATE_RESET = "COURSE_CREATE_RESET";

export const COURSE_DETAILS_REQUEST = "COURSE_DETAILS_REQUEST";
export const COURSE_DETAILS_SUCCESS = "COURSE_DETAILS_SUCCESS";
export const COURSE_DETAILS_FAIL = "COURSE_DETAILS_FAIL";
export const COURSE_DETAILS_RESET = "COURSE_DETAILS_RESET";

export const COURSE_CREATE_REQUEST2 = "COURSE_CREATE_REQUEST2";
export const COURSE_CREATE_SUCCESS2 = "COURSE_CREATE_SUCCESS2";
export const COURSE_CREATE_FAIL2 = "COURSE_CREATE_FAIL2";
export const COURSE_CREATE_RESET2 = "COURSE_CREATE_RESET2";

export const COURSE_LIST_REQUEST = "COURSE_LIST_REQUEST";
export const COURSE_LIST_SUCCESS = "COURSE_LIST_SUCCESS";
export const COURSE_LIST_FAIL = "COURSE_LIST_FAIL";
export const COURSE_LIST_RESET = "COURSE_LIST_RESET";
